<h1 mat-dialog-title>Add Paid Per Diem</h1>

<mat-dialog-content>
  @if (costCenter) {
    @if (employeesCount > 0) {
      <div class="mb-1 flex flex-row justify-end">
        <span class="text-sm uppercase">week ending {{ weDate }}</span>
      </div>
      <div class="mb-2 flex items-center justify-between bg-[#ececec] p-2">
        <h3 class="text-xl font-semibold">
          @if (employeesCount === 1) {
            Add to 1 Employee
          } @else if (employeesCount === 2) {
            Add to 2 Employees
          } @else {
            Add to all {{ employeesCount }} Employees
          }
        </h3>
        <div class="flex flex-col text-end text-sm">
          <span>Cost Center {{ costCenter }}</span>
          <span>{{ formattedDate }}</span>
        </div>
      </div>
      <table class="w-full">
        <tbody>
          @for (item of tableValues; track item) {
            <tr>
              <td class="w-1/2 pr-2">
                <label class="block text-right" [for]="'perdiem-' + $index">{{ item.label }}</label>
              </td>
              <td>
                <mat-form-field class="mb-2 w-24">
                  <input
                    matInput
                    type="number"
                    placeholder="0.00"
                    min="0"
                    [id]="'perdiem-' + $index"
                    [(ngModel)]="item.perDiemAmount"
                  />
                  <span matTextPrefix>$&nbsp;</span>
                </mat-form-field>
              </td>
            </tr>
          }
          <tr>
            <td class="w-1/2 pr-2 pt-2">
              <div class="text-right">
                <strong>Total</strong>
              </div>
            </td>
            <td class="pl-3 pt-2">
              <strong>{{ totalPerDiemAmount | currency }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    } @else {
      <h3 class="text-center text-xl text-red-600">
        There are no employees in Cost Center <strong>{{ costCenter }}</strong
        >.
      </h3>
      <h4 class="text-lg">Try selecting a different cost center that has employees listed.</h4>
    }
  } @else {
    <h3 class="text-center text-xl text-red-600">Please Choose a Cost Center!</h3>
    <h4 class="text-lg">You can't add a Per Diem to all employees on all Cost Centers.</h4>
  }
</mat-dialog-content>

@if (costCenter && employeesCount > 0) {
  <mat-dialog-actions>
    <button mat-raised-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="totalPerDiemAmount <= 0" (click)="confirm()">
      Add {{ totalPerDiemAmount | currency }} / employee
    </button>
  </mat-dialog-actions>
}
